import React from "react";
import { Row, Col, Modal, Button, Form } from "@themesberg/react-bootstrap";
import { useState } from "react";
import { getYearsList } from "../../../helpers/helper";
import Select from 'react-select';

const ModalDuplicateKodepay = ({ cb, ...props }) => {
  const [tahun, setTahun] = useState(null);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={props.onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Duplikasi?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Tahun</Form.Label>
            <Select
              options={getYearsList()}
              placeholder="Pilih Tahun"
              required
              autoFocus
              onChange={(e) => {
                setTahun(e.value)
              }}
            />
          </Form.Group>
          <Row className="justify-content-end">
            <Col xs="auto">
              <Button variant="success" onClick={() => cb(tahun)}>
                Simpan
              </Button>
            </Col>
            <Col xs="auto">
              <Button variant="warning" onClick={props.onClose}>
                Batal
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalDuplicateKodepay;
